export type EventGallery = {
  name: string
  photoUrls: string[]
}

export const gallery: EventGallery[] = [
  {
    name: 'Soldiers Q&A',
    photoUrls: [
      'https://as2.ftcdn.net/v2/jpg/05/68/55/85/1000_F_568558545_v7emPoS2EuXaSc2ULRkioUDgzepiQ2IS.jpg',
      'https://i.pinimg.com/736x/19/d7/f6/19d7f6a1f09c7569c8648d22a38ab737.jpg',
    ],
  },
  {
    name: 'Other event',
    photoUrls: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDdZirLb_SZW1Yv0rH6IzQutryc2fP11hU5g&s',
      'https://img.freepik.com/premium-photo/isometric-image-ultra-realistic-raccoon-business-meeting-scene-perfect-corporate-collaborati_980716-133724.jpg',
      'https://www.kark.com/wp-content/uploads/sites/85/2018/02/raccoon_1518370395979_33816586_ver1.0.jpg?w=1280',
      'https://beachmetro.com/wp-content/uploads/2024/09/web-Wild-Side-beach-metro-roof.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2iM83QU259rACB-6HmPxR0_ojfR3dRS2cwQ&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpT5NfeqFBBw_VKjtxpT8bcRQHHPKvpBSORw&s',
    ],
  },
]
